import { Location } from '@angular/common'
import { Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(private router: Router, private location: Location) {}

  private history: string[] = []
  public startSaveHistory(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.indexOf('null') === -1)
          this.history.push(event.urlAfterRedirects)
      }
    })
  }

  public getHistory(): string[] {
    return this.history
  }

  public goBack(): void {
    this.history.pop()

    if (this.history.length > 0) {
      this.location.back()
    } else {
      this.router.navigateByUrl('/')
    }
  }

  public getPreviousUrl(): string {
    if (this.history.length > 0) {
      return this.history[this.history.length - 2]
    }

    return ''
  }
}
